import * as React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import CmdBox from '@commander-services/cmd-box';
import TooltipComponent from '../../../TooltipComponent';

interface IProps {
  tableData: Record<string, any>;
  vehicleId: string;
}

function OnlineViolationsTable(props: IProps) {
  const { formatMessage: f } = useIntl();

  const getDescribingEnabledBoolean = () => {
    let describingEnabled = true;
    if (props.tableData) {
      Object.values(props.tableData).forEach((i) => {
        if (i.describingEnabled === false) {
          describingEnabled = false;
        }
      });
      return describingEnabled;
    }
    return describingEnabled;
  };

  const getIsPublicTd = (value: string) => {
    const result = true;
    // if (props.responseData) {
    //   const driverId = props.responseData.driver?.id;
    //   const customerId = props.responseData.graph?.customerId;
    //   const isPrivate = props.responseData.ride?.isPrivate;
    //   if (customerId && driverId) {
    //     result = GdprService.getRideGdpr('showPrivateData', isPrivate, customerId, driverId);
    //   }
    // }
    return result && value !== '-';
  };

  return (
    <div style={{ marginTop: '-12px' }}>
      <CmdBox id="violations" title={f({ id: 'tripsOverview.section.recent.violations' })}>
        <div id="tableWrapper">
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-listings m-0 border-0 border-top-on">
              <thead id="tableThead" className="tableThead">
                <tr>
                  <th
                    style={{
                      whiteSpace: 'nowrap',
                      paddingRight: '7px',
                    }}
                  >
                    {f({ id: 'tripsOverview.section.violation.tooltip' })}
                  </th>
                  <th
                    style={{
                      whiteSpace: 'nowrap',
                      paddingRight: '7px',
                    }}
                  >
                    {f({ id: 'tripsOverview.section.time.tooltip' })}
                  </th>
                  <th
                    style={{
                      whiteSpace: 'nowrap',
                      paddingRight: '7px',
                    }}
                  >
                    {f({ id: 'tripsOverview.section.duration.tooltip' })}
                  </th>
                  <th
                    style={{
                      whiteSpace: 'nowrap',
                      paddingRight: '7px',
                    }}
                  >
                    {f({ id: 'tripsOverview.section.maxValue.tooltip' })}
                  </th>
                  <th
                    style={{
                      whiteSpace: 'nowrap',
                      paddingRight: '7px',
                    }}
                  >
                    {f({ id: 'table_list.columns.positions.coordinates' })}
                  </th>
                  {getDescribingEnabledBoolean() && (
                    <th
                      style={{
                        whiteSpace: 'nowrap',
                        paddingRight: '7px',
                      }}
                    >
                      {f({ id: 'ridePlayer.selectRidesModal.table.address' })}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {props.tableData.length > 0 &&
                  Object.values(props.tableData).map((i) => (
                    <tr className="height-md" style={{ whiteSpace: 'nowrap' }}>
                      <td>{f({ id: `tripsOverview.section.${i.type}.tooltip` })}</td>
                      <td>{dayjs(i.timestamp).format('DD.MM.YYYY HH:mm:ss')}</td>
                      <td style={{ textAlign: 'right' }}>{i.duration}</td>
                      <td style={{ textAlign: 'right' }}>
                        {i.maxValue.tooltip ? (
                          <TooltipComponent
                            id={`tltp-${props.vehicleId}`}
                            // firstItems={this.props.firstItems}
                            overlay={<div style={{ color: '#fff' }}>{i.maxValue.tooltip}</div>}
                          >
                            {i.maxValue.value}
                          </TooltipComponent>
                        ) : (
                          i.maxValue.value
                        )}
                      </td>
                      <td style={{ cursor: 'pointer' }}>
                        {getIsPublicTd(i.map) ? (
                          <a href={i.links.map} target="_blank" rel="noreferrer">
                            {i.map}
                          </a>
                        ) : (
                          f({ id: 'rides.privateRide' })
                        )}
                      </td>
                      {getDescribingEnabledBoolean() && (
                        <td style={{ cursor: 'pointer' }}>
                          {getIsPublicTd(i.address) ? (
                            <a href={i.links.map} target="_blank" rel="noreferrer">
                              {i.address}
                            </a>
                          ) : (
                            f({ id: 'rides.privateRide' })
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </CmdBox>
    </div>
  );
}

export default React.memo(OnlineViolationsTable);
